import { Auth } from "shared/@auth/Auth";
import { useMutation, useQuery, useQueryClient } from "react-query";

export function useExchangeTicket({ iboNumber, eventId }) {
  const { makeAuthedRequest } = Auth.useContainer();
  const queryClient = useQueryClient();

  const { data, isError, isLoading, refetch, error } = useQuery(
    ["availableTickets", iboNumber, eventId],
    () =>
      makeAuthedRequest(
        `v1/events/new/order/tickets/ibo/${iboNumber}/eventId/${eventId}`,
        {
          method: "GET",
        }
      ).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(getErrorMessage(body));
        }
      })
    // {
    //   enabled: enabled && !!iboNumber && !!eventId,
    //   staleTime: 0,
    // }
  );

  const exchangeOrder = useMutation(
    async (order) => {
      const res = await makeAuthedRequest(
        `v1/events/new/order/exchange/ibo/${iboNumber}`,
        {
          method: "POST",
          body: JSON.stringify(order),
        }
      );

      if (res.ok) {
        return res;
      } else {
        const body = await res.json();
        throw new Error(getErrorMessage(body));
      }
    },
    {
      onSuccess: () => {
        queryClient.refetchQueries(["newibo", iboNumber]);
      },
    }
  );

  return {
    data,
    refetch,
    isError,
    isLoading,
    error,
    exchangeOrder,
  };
}

const getErrorMessage = (body) => {
  const possibleMessages = [
    body?.error?.message?.message?.responsetext,
    body?.error?.message?.message?.responseText,
    body?.error?.message?.message?.message,

    body?.error?.message?.responsetext,
    body?.error?.message?.responseText,
    body?.error?.message?.message,

    body?.error?.responsetext,
    body?.error?.responseText,
    body?.error?.message,

    body?.message?.message?.responsetext,
    body?.message?.message?.responseText,
    body?.message?.message?.message,

    body?.message?.responsetext,
    body?.message?.responseText,
    body?.message?.message,

    typeof body?.error === "string" ? body.error : null,
    typeof body?.message === "string" ? body.message : null,
  ];

  return (
    possibleMessages.find(
      (value) => typeof value === "string" && value.trim()
    ) || "Unknown error"
  );
};
